import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'

type Props = {
  onClickEdit: () => void
  onClickDelete: () => void
  showDuplicateButton?: boolean
  onClickDuplicate?: () => void
}

export const EditAndDeleteButtons: FC<Props> = ({
  onClickEdit,
  onClickDelete,
  showDuplicateButton = false,
  onClickDuplicate,
}) => {
  const { t } = useTranslation(['companies-users-[id]'])
  return (
    <div className={styles.container}>
      <button type='button' onClick={onClickEdit}>
        {t('編集')}
      </button>{' '}
      {showDuplicateButton && (
        <>
          /{' '}
          <button type='button' onClick={onClickDuplicate}>
            {t('複製')}
          </button>{' '}
        </>
      )}
      /{' '}
      <button type='button' onClick={onClickDelete}>
        {t('削除')}
      </button>
    </div>
  )
}
